import { createContext, useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import About from "@/pages/About";
import Info from "@/pages/Info";

export const LenisContext = createContext(null);

const ScrollManager = ({ lenisRef }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, lenisRef]);
  return null;
};

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LenisContext.Provider value={lenisRef}>
      <BrowserRouter>
        <ScrollManager lenisRef={lenisRef} />
        <div className="min-h-screen bg-moss-950 text-ivory font-sans">
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/collection/:slug" element={<ProductPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/info" element={<Info />} />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
    </LenisContext.Provider>
  );
}

export default App;
